export default __webpack_public_path__ + "static/media/aptdoc_kralova_ikona_home.c2e9fcb6.svg";